import { createToaster } from '@ark-ui/solid/toast';
import type { CreateToasterReturn } from '@ark-ui/solid/toast';

const sym = Symbol.for('toaster');
// @ts-expect-error cannot type symbols on global
globalThis[sym] ??= createToaster({
	placement: 'bottom-end',
	overlap: true,
	gap: 16,
	pauseOnPageIdle: true,
	duration: 40_000,
});

// @ts-expect-error cannot type symbols on global
export const toaster = globalThis[sym] as CreateToasterReturn;
